import { HolidayEvent } from "@/generated/graphql/b2c";

export const NY_HOLIDAY_CODE = "holiday2026";

export class Holidays {
  holidays: HolidayEvent[] = [];

  setPreloadedHolidays(holidayEvents: HolidayEvent[]) {
    this.holidays = holidayEvents;
  }

  getNy(): HolidayEvent | undefined {
    return this.holidays.find((holiday: HolidayEvent) => {
      return holiday.code === NY_HOLIDAY_CODE;
    });
  }
}
